// extracted by css-extract-rspack-plugin
export default {"Anchor":"RightClickPopover-module__Anchor___yLfXG"};